import React from 'react';

import { SkeletonItem } from '@atlaskit/menu';

import { type SkeletonListProps } from './types';

const SkeletonList = ({ hasIcon, hasAvatar, isShimmering, xcss, itemCount }: SkeletonListProps) => {
	return (
		<>
			{Array(itemCount)
				.fill(undefined)
				.map((_, index) => (
					<SkeletonItem
						key={`skeleton-${index}`}
						hasAvatar={hasAvatar}
						hasIcon={hasIcon}
						isShimmering={isShimmering}
						xcss={xcss}
					/>
				))}
		</>
	);
};

export default SkeletonList;
